import(/* webpackMode: "eager" */ "/codebuild/output/src3361082059/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3361082059/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
